var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderList"},[_c('div',{staticClass:"title"},[_c('img',{attrs:{"src":require("../../../../src/assets/image/black.png"),"alt":""},on:{"click":_vm.goblack}}),_c('span',[_vm._v(_vm._s(_vm.name))])]),_c('div',{staticClass:"ruletext",domProps:{"innerHTML":_vm._s(_vm.ruleText)}}),_c('bottomList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }